export const initialResetPassword = {
  password: '',
  repeatPassword: '',
};

export const initialResetEmail = {
  email: '',
};

export const initialValuesSignIn = {
  email: '',
  password: '',
};

export const initialValuesSingUp = {
  password: '',
  repeatpassword: '',
  acceptTerms: false,
};

export const initialCode = { code: '' };
